module.exports = __webpack_public_path__ + "media/src/images/logo-without-text-d9413aef97234aa5a738d37589b29f59.svg";